export default {
    title: 'Your order has been shipped!',
    message: {
        text1: 'Your order has been sent and is currently being processed.',
        text2: 'You can monitor the status of orders in the',
        myOrderSection: 'My Orders section.'
    },
    orderOverview: 'Order overview',
    payedOnline: 'Overview of the bill payed online',
    payedWithCash: 'Overview of the bill we pay by cash on delivery',
    successful: 'successful',
    unsuccessful: 'unsuccessful',
    orderDate: 'Order date',
    orderNumber: 'Order number',
    paymentMethod: {
        title: 'Payment method',
        cashOnDelivery: 'By cash on delivery',
        creditCard: 'Credit card'
    },
    transactionInfo: {
        title: 'Transaction information',
        status: 'Status',
        code: 'Transaction code',
        payment: 'Payment',
        authCode: 'Bank Authorization Code',
        date: 'Transaction date',
        atTheLatest: 'Estimated delivery date:'
    },
    note: "Note",
    storePriceSummary: {
        sum: 'Sum',
        surcharge: 'Surcharge',
        delivery: 'Delivery',
        total: 'Total'
    },
    deliveryAddress: 'Delivery address',
    footer: {
        message: {
            sendYouEmail: 'Soon we will send you an order confirmation to your email address.',
            thanksForBuying: 'Thank you for buying with'
        },
        okButton: 'OK'
    },
    atTheLatest: 'at the latest',
    transactionSuccessful: 'Transaction was successful',
    tryAgain: 'Try again',
    cardError: {
        code: 'Your card cannot be accepted. Please try with another card or contact your issuing bank.',
        code1000: 'CONFIG ERROR. Some fundamental error in your request.',
        code1001: 'CONFIG ERROR. The upstream system responded with an unknown response.',
        code1002: 'CONFIG ERROR. Request data are malformed or missing.',
        code1003: 'CONFIG ERROR. Transaction could not be processed.',
        code1004: 'CONFIG ERROR. The request signature you provided was wrong.',
        code1005: 'CONFIG ERROR. The XML you provided was malformed or invalid.',
        code1006: 'CONFIG ERROR. Preconditions failed, e.g. capture on a failed authorize.',
        code1007: 'CONFIG ERROR. Something is wrong your configuration, please contact your integration engineer.',
        code1008: 'CONFIG ERROR. Unexpected system error.',
        code9999: 'We received an error which is not (yet) mapped to a better error code.',
        code2001: 'The customer cancelled permission for his payment instrument externally. Please try with another card.',
        code2002: 'Transaction was cancelled by customer.',
        code2003: 'Transaction declined by the bank. Please try with another card.',
        code2004: 'Some limit reached. Please try with another card.',
        code2005: 'Transaction expired. Customer took to long to submit his payment info.',
        code2006: 'Insufficient funds/Card limit reached. Please try with another card.',
        code2007: 'Incorrect payment info. Please check and try again.',
        code2008: 'Invalid card. Please try with another card.',
        code2009: 'Expired card. Please try with another card.',
        code2010: 'Your card cannot be accepted. Please try with another card or contact your issuing bank.',
        code2011: 'Your card cannot be accepted. Please try with another card or contact your issuing bank.',
        code2012: 'Transaction cancelled.',
        code2013: 'Your card cannot be accepted. Please try with another card or contact your issuing bank.',
        code2014: 'Your card cannot be accepted. Please try with another card or contact your issuing bank.',
        code2015: 'Your card cannot be accepted. Please try with another card or contact your issuing bank.',
        code2016: 'Your card cannot be accepted. Please try with another card or contact your issuing bank.',
        code2017: 'IBAN not valid. Please check and try again.',
        code2018: 'BIC invalid. Please check and try again.',
        code2019: 'Customer data invalid. Please check and try again.',
        code2020: 'CVV required. Please check and try again.',
        code2021: '3D-Secure Verification failed. Please with non 3D-Secure card or contact your issuing bank.',
        code3001: 'COMMUNICATION ERROR: Timeout. Please try again later.',
        code3002: 'COMMUNICATION ERROR: Transaction not Allowed.',
        code3003: 'COMMUNICATION ERROR: System temporary unavailable. Please try again later.',
        code3004: 'Duplicate transaction ID.',
        code3005: 'COMMUNICATION ERROR: Please try again later.',
        code7001: 'Schedule request is invalid.',
        code7002: 'Schedule request failed.',
        code7005: 'ScheduleAction is not valid.',
        code7010: 'RegistrationId is required.',
        code7020: 'RegistrationId is not valid.',
        code7030: 'Reference transaction not a register.The registrationId must point to a register or a debit-with-register or a preauthorize-with-register.',
        code7035: 'Initial transaction is not a register.The transaction for starting a schedule must be a register, a debit-with-register or a preauthorize-with-register.',
        code7036: 'Invalid initial period. The period between the initial and second transaction must be greater than 24 hours.',
        code7040: 'The scheduleId is not valid or does not match to the connector.',
        code7050: 'The startDateTime is invalid or older than 24 hours.',
        code7060: 'The continueDateTime is invalid or older than 24 hours.',
        code7070: 'The status of the schedule is not valid for the requested operation.',
    }
}
